import { styled } from "external/material"
import { centerVertically } from "utils/style"

import GroupFilter from "components/GroupFilter"
import EventTypeCategory from "components/EventCategoryFilter"

const StyledFilters = styled('div')(filterStyles)

export default function Filters () {
    return (
      <StyledFilters className="filters-wrapper">
        <div className="filters">
            <GroupFilter className="group" preserveQuery />
            <EventTypeCategory className="type" preserveQuery />
        </div>
      </StyledFilters>
    )
}

function filterStyles(){
    return {
        backgroundColor: '#fff',
        padding: '4px 5px 13px 15px',
        ...centerVertically,
        "& .filters": {
            display: 'flex',
            "& .group": {
                width: 250
            },
            "& .type": {
                marginLeft: 15,
                width: 220
            }
        }
    }
}